import React from 'react';
import Loadable from 'react-loadable';

function Loader(props) {
  if (props.isLoading) {
    if (props.timedOut) {
      return <div>Loader timed out!</div>;
    } else if (props.pastDelay) {
      return <div>Loading...</div>;
    } else {
      return null;
    }
  } else if (props.error) {
    throw props.error;
  } else {
    return null;
  }
}

// eslint-disable-next-line new-cap
const FeatureToggleLoader = Loadable({
  loader: () => import('./FeatureToggle'),
  loading: Loader
});

export default FeatureToggleLoader;



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/FeatureToggleLoader.js